import { useState } from 'react';
import { useAuth } from './AuthProvider.js';
import { Button } from '../../components/ui/Button.js';

export function SignInScreen() {
  const { signInWithGoogle } = useAuth();
  const [error, setError] = useState<string | null>(null);

  async function handleClick() {
    setError(null);
    try {
      await signInWithGoogle();
    } catch {
      setError('Sign-in was cancelled or failed. Please try again.');
    }
  }

  return (
    <div className="flex min-h-dvh items-center justify-center bg-bg p-4">
      <div className="flex w-full max-w-sm flex-col items-center gap-6 rounded-card border border-border bg-surface p-6 text-center shadow-sm sm:p-8">
        <img src="/logo.png" alt="" width="48" height="48" className="logo-pulse" />
        <div>
          <h1 className="font-heading font-semibold text-2xl">Allemnii Pulse</h1>
          <p className="mt-1 text-sm text-muted">Sign in with your company Google account.</p>
        </div>
        <Button variant="default" className="h-10 w-full justify-center" onClick={handleClick}>
          Sign in with Google
        </Button>
        {error && <p className="text-sm text-danger">{error}</p>}
      </div>
    </div>
  );
}
